const ACTIVE_COMPANY_STORAGE_KEY = 'activeCompanyId';

export const USE_MULTI_COMPANY = false;
// Cuando migremos de verdad, esto pasa a true.

export const DEFAULT_COMPANY_ID = 'default';
export const DEFAULT_COMPANY_NAME = 'Empresa Base';
export const DEFAULT_COMPANY_PLAN = 'base';

const normalizeCompanyId = (companyId = DEFAULT_COMPANY_ID) => {
  const value = String(companyId || DEFAULT_COMPANY_ID).trim();
  return value || DEFAULT_COMPANY_ID;
};

export const isMultiCompanyEnabled = () => USE_MULTI_COMPANY;

export const getStoredActiveCompanyId = () => {
  if (typeof window === 'undefined') return null;

  try {
    return localStorage.getItem(ACTIVE_COMPANY_STORAGE_KEY);
  } catch (error) {
    console.warn('No se pudo leer activeCompanyId desde localStorage:', error);
    return null;
  }
};

export const setActiveCompanyId = (companyId) => {
  const normalized = normalizeCompanyId(companyId);

  if (typeof window === 'undefined') return normalized;

  try {
    localStorage.setItem(ACTIVE_COMPANY_STORAGE_KEY, normalized);
  } catch (error) {
    console.warn('No se pudo guardar activeCompanyId en localStorage:', error);
  }

  return normalized;
};

export const clearActiveCompanyId = () => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(ACTIVE_COMPANY_STORAGE_KEY);
  } catch (error) {
    console.warn('No se pudo limpiar activeCompanyId de localStorage:', error);
  }
};

export const getActiveCompanyId = () => {
  if (!USE_MULTI_COMPANY) return DEFAULT_COMPANY_ID;

  const storedCompanyId = getStoredActiveCompanyId();
  return normalizeCompanyId(storedCompanyId || DEFAULT_COMPANY_ID);
};

export const getActiveCompanyName = () => DEFAULT_COMPANY_NAME;

export const getDefaultCompanyRecord = (overrides = {}) => ({
  companyId: DEFAULT_COMPANY_ID,
  companyName: DEFAULT_COMPANY_NAME,
  slug: DEFAULT_COMPANY_ID,
  isActive: true,
  plan: DEFAULT_COMPANY_PLAN,
  ...overrides
});

export const getDefaultCompanyModules = () => ({
  logistics: true,
  stock: true,
  liquidation: true,
  transporterHistory: false,
  advancedMonitor: false
});

export const getDefaultCompanyOfficeSettings = () => ({
  name: 'Oficina Central',
  officeName: 'Oficina Central',
  shortName: 'OC',
  address: '',
  fullAddress: '',
  lat: null,
  lng: null
});

export const getDefaultCompanyLiquidationSettings = () => ({
  enabled: true,
  pricePerKm: 0,
  baseRouteFee: 0,
  pricePerCompletedStop: 0,
  pricePerPickup: 0,
  urgentSurcharge: 0,
  incompleteMultiplier: 0.5,
  cancelledMultiplier: 0
});

export const getDefaultCompanyMainSettings = () => ({
  companyId: DEFAULT_COMPANY_ID,
  companyName: DEFAULT_COMPANY_NAME,
  plan: DEFAULT_COMPANY_PLAN,
  modules: getDefaultCompanyModules(),
  officeLocation: getDefaultCompanyOfficeSettings(),
  liquidationSettings: getDefaultCompanyLiquidationSettings(),
  ui: {
    showCompanyNameInHeader: true
  }
});

export const getDefaultCompanySettingsBundle = (companyId = DEFAULT_COMPANY_ID) => {
  const normalizedCompanyId = normalizeCompanyId(companyId);

  return {
    company: getDefaultCompanyRecord({
      companyId: normalizedCompanyId,
      slug: normalizedCompanyId
    }),
    settings: {
      main: {
        ...getDefaultCompanyMainSettings(),
        companyId: normalizedCompanyId
      },
      general: {
        companyId: normalizedCompanyId,
        companyName: DEFAULT_COMPANY_NAME,
        isActive: true
      },
      modules: {
        companyId: normalizedCompanyId,
        ...getDefaultCompanyModules()
      },
      office: {
        companyId: normalizedCompanyId,
        ...getDefaultCompanyOfficeSettings()
      },
      liquidation: {
        companyId: normalizedCompanyId,
        ...getDefaultCompanyLiquidationSettings()
      },
      plan: {
        companyId: normalizedCompanyId,
        plan: DEFAULT_COMPANY_PLAN
      },
      logisticsMonitor: {
        companyId: normalizedCompanyId,
        showCompletedRoutes: true,
        showCancelledRoutes: true
      }
    }
  };
};

export const mergeCompanySettingsWithDefaults = (rawSettings = {}, companyId = DEFAULT_COMPANY_ID) => {
  const normalizedCompanyId = normalizeCompanyId(companyId);
  const defaults = getDefaultCompanyMainSettings();

  return {
    ...defaults,
    ...rawSettings,
    companyId: normalizedCompanyId,
    companyName: rawSettings.companyName || defaults.companyName,
    plan: rawSettings.plan || defaults.plan,
    modules: {
      ...defaults.modules,
      ...(rawSettings.modules || {})
    },
    officeLocation: {
      ...defaults.officeLocation,
      ...(rawSettings.officeLocation || {})
    },
    liquidationSettings: {
      ...defaults.liquidationSettings,
      ...(rawSettings.liquidationSettings || {})
    },
    ui: {
      ...defaults.ui,
      ...(rawSettings.ui || {})
    }
  };
};